<template>
  <div class="company_info">
    <h3>輔助開通請聯繫客服熱線：0755-83660999</h3>
    <div class="details">
      <el-row v-for="item in companyInfoList" :key="item.name">
        <el-col :span="isPc?4:6" class="tag"
          ><span v-if="item.isrequired">*</span>{{ item.name }}</el-col
        >
        <el-col :span="isPc?16:14">
          <div v-if="item.type == 'company_logo'">
            <el-upload
            ref="upload"
              class="avatar-uploader"
              action="https://qinius.ts960.com/"
              :data="qn"
              :show-file-list="false"
              :on-success="handleLogoSuccess"
              :before-upload="beforeAvatarUpload"
            >
              <el-image
              style="width: 200px; "
              v-if="item.value" :src="$imgUrl+item.value"
              :fit="contain"></el-image>
              <!-- <img v-if="item.value" :src="$imgUrl+item.value" class="avatar" /> -->
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </div>
          <div v-else-if="item.type == 'slideshow_img'">
            <el-upload
              class="avatar-uploader"
              action="https://qinius.ts960.com/"
              :data="qn"
              :show-file-list="false"
              :on-success="handleSlideSuccess"
              :before-upload="beforeAvatarUpload"
            >
              <el-image
                style="width: 200px; "
                v-if="item.value" :src="$imgUrl+item.value"
                :fit="contain"></el-image>
              <!-- <img v-if="item.value" :src="$imgUrl+item.value" class="avatar" /> -->
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </div>
          <div v-else-if="item.type == 'field'">
            <el-select v-model="item.value" placeholder="請選擇行業分類">
              <el-option
                v-for="item in options"
                :key="item.industry_id"
                :label="item.industry_name"
                :value="item.industry_id"
              >
              </el-option>
            </el-select>
          </div>
          <div v-else>
            <el-input
              v-model="item.value"
              :placeholder="'請輸入' + item.name"
            ></el-input>
          </div>
        </el-col>
      </el-row>
      <el-button type="primary" v-if="!isUpdate" @click="submitEnterprisesInfo">保存</el-button>
      <el-button type="primary" v-else @click="updateEnterprisesInfo">修改</el-button>
    </div>
    <el-dialog
      :visible.sync="isHasAssociation"
      title="您還未加入協會"
      :width="isPc?'450px':'310px'" center 
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      >
        <i class="el-icon-close" @click="goBack"></i>
      <div class="pop-con" v-if="showBtns">
        <button class="little_hand" @click="applyForAdmission">立即加入</button>
        <button class="little_hand" @click="goBack">以後再說</button>
      </div>
      <div class="contact" v-else>
        <button><em></em><span>聯繫電話：<b>0755-83660999</b></span></button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { mapState } from "vuex";
import * as qiniu from 'qiniu-js'

export default {
  data() {
    return {
      isHasAssociation:false,
      showBtns:true,
      qn: {
        token: "",
        key: "avatar_" + Date.now() + "_" + Math.random(),
      },
      isUpdate:false,//是否是更新企業
      company_id:'',
      companyInfoList: [
        {
          name: "企業名稱",
          value: "",
          type: "company_name",
          isrequired: true,
        },
        {
          name: "企業logo",
          value: "",
          type: "company_logo",
          isrequired: true,
        },
        {
          name: "封面圖",
          value: "",
          type: "slideshow_img",
          isrequired: false,
        },
        {
          name: "行業分類",
          value: "",
          type: "field",
          isrequired: true,
        },
        {
          name: "主營產品",
          value: "",
          type: "main_businee",
          isrequired: true,
        },
        {
          name: "企業地址",
          value: "",
          type: "address",
          isrequired: true,
        },
        {
          name: "聯繫電話",
          value: "",
          type: "phone",
          isrequired: true,
        },
        {
          name: "聯繫郵件",
          value: "",
          type: "email",
          isrequired: false,
        },
      ],
      options: [
        {
          industry_name: "",
          industry_id: "",
        },
      ],
      value: "",
    };
  },
  computed: {
    ...mapState(['isPc',"userInfo", "user_id"]),
    submitData() {
      let submitDataRes = {};
      this.companyInfoList.map((item) => {
        submitDataRes[item.type] = item.value;
      });
      return submitDataRes;
    },
  },
  watch: {
    user_id(val){
      this.getMyAssociationList()
      this.getMyCompanyInfo()
    }
  },
  methods: {
    goBack(){
      this.isHasAssociation=false
      this.$router.back();
    },
    applyForAdmission(){
      this.$router.push({
        path: `/apply`,
      });
    },
    handleLogoSuccess(res, file) {
      this.fnUploadFile(file.raw,1)
      // this.companyInfoList[1].value = URL.createObjectURL(file.raw);

    },
    handleSlideSuccess(res, file) {
      this.fnUploadFile(file.raw,2)
      // this.companyInfoList[2].value = URL.createObjectURL(file.raw);
    },
    beforeAvatarUpload(file) {
      // console.log('文件大小======',file)
      const isPNG = file.type === "image/png";
      const isJPEG = file.type === "image/jpeg";
      const isJPG = file.type === "image/jpg";
      const isLt6M = file.size / 1024 / 1024 < 6;

      if (!isPNG && !isJPEG && !isJPG) {
        this.$message.error("上傳圖片只能是jpg、png、jpeg格式!");
        return false;
      }
      if (!isLt6M) {
        this.$message.error("上傳圖片大小不能超過 6MB!");
        return false;
      }
    },
    //上传图片至七牛云
    fnUploadFile(raw,th) {
      let vm = this;
      let key = 'avatar_' + Date.now() + '_' + Math.random();
      let file = raw;
      var putExtra = {
        fname: key,
        mimeType: ["image/png", "image/jpeg", "image/gif"]//限制上传类型
      };
      let config = {
        useCdnDomain: true,
        region: qiniu.region.z0
      };
      let observer = {
        next(res){
          // ...
        },
        error(err){
          // console.log('失败====',err);
        },
        complete(res){
          // console.log('上传图片====',JSON.stringify(res))
          vm.companyInfoList[th].value = res.key
        }
      }
      var observable = qiniu.upload(file, key, this.qn.token, putExtra, config)
      var subscription = observable.subscribe(observer) // 上传开始
    },
    async getQiniuToken() {
      const { data: res } = await this.$http.get(`/api/v2/qiniu/getUptoken`);
      if (!res.sucess) return this.$message.error("獲取失敗");
      this.qn.token = res.data;
      // console.log("七牛云=====", res);
    },
    //获取我的企业
    async getMyCompanyInfo() {
      const { data: res } = await this.$http.get(`/api/v2/member/${this.user_id}/company`);
      if (!res.sucess) return this.$message.error("獲取失敗");
      if(res.data.length>0){
        this.isUpdate=true;
        this.company_id=res.data[0].company_id;
        this.companyInfoList.map(item=>{
          item.value=res.data[0][item.type]
        })
      }
      this.$zhTran()
      // console.log(this.companyInfoList)
    },
    // 获取行业分类
    async getIndustryClassification() {
      const { data: res } = await this.$http.get(`/api/v2/company/industry`);
      if (!res.sucess) return this.$message.error("獲取失敗");
      this.options = res.data.map((item) => {
        return {
          industry_name: item.industry_name,
          industry_id: item.industry_id,
        };
      });
      this.$zhTran()
    },
    // 开通企业信息
    async submitEnterprisesInfo() {
      // console.log(this.submitData);
      this.submitData.member_id = this.user_id;
      if (
        !this.submitData.company_name ||
        !this.submitData.company_logo ||
        !this.submitData.field ||
        !this.submitData.main_businee ||
        !this.submitData.address ||
        !this.submitData.phone
      )
        return this.$message.error("請填寫完整信息");
      const { data: res } = await this.$http.post(
        `/api/v2/company/addCompany`,
        this.submitData
      );
      if (!res.sucess) return this.$message.error("獲取失敗");
      this.$message.success("開通企業成功");
    },
    //更新企业信息
    async updateEnterprisesInfo(){
      this.submitData.member_id = this.user_id;
      this.submitData.company_id=this.company_id;
      if (
        !this.submitData.company_name ||
        !this.submitData.company_logo ||
        !this.submitData.field ||
        !this.submitData.main_businee ||
        !this.submitData.address ||
        !this.submitData.phone
      )
        return this.$message.error("請填寫完整信息");
      const { data: res } = await this.$http.post(
        `/api/v2/member/updateCompany`,
        this.submitData
      );
      if (!res.sucess) return this.$message.error("獲取失敗");
      this.$message.success("修改信息成功");
    },
    async getMyAssociationList(){
      const { data: res } = await this.$http.get(`/api/v2/member/${this.user_id}/association`,);
      if (!res.sucess) return this.$message.error("獲取失敗");
      // console.log('我的协会====',res.data)
      if(res.data.length>0){
        let filterArr=res.data.filter(item=>{
          if(item.association_id=='SZTX'){
            return item
          }
        })
        // console.log(filterArr)
        if(filterArr.length==0){
          this.isHasAssociation=true;
        }
      }else{
        this.isHasAssociation=true;
      }
    }
  },
  created() {
    this.getQiniuToken();
    this.getIndustryClassification();
  },
  mounted() {
    if(this.user_id){
      this.getMyAssociationList()
      this.getMyCompanyInfo();
    }
  },
};
</script>

<style lang="less" scoped>
.company_info {
  margin-left: 20px;
  border: 1px solid #ebeaeb;
  padding: 40px;
  flex: 1;
  margin-bottom: 40px;
  h3 {
    font-size: 18px;
    font-weight: 400;
    color: #333333;
    line-height: 22px;
  }
  .el-row {
    margin-top: 20px;
    .tag {
      font-size: 16px;
      font-weight: 400;
      color: #666;
      position: relative;
      span {
        color: #f00;
        position: absolute;
        left: -10px;
      }
    }
    .avatar-uploader .el-upload {
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
    }
    .avatar-uploader .el-upload:hover {
      border-color: #409eff;
    }
    .avatar-uploader-icon {
      font-size: 44px;
      color: #e4e4e4;
      width: 100px;
      height: 100px;
      line-height: 100px;
      text-align: center;
      background: #f6f6f6;
    }
    .avatar {
      width: 100px;
      height: 100px;
      display: block;
    }
    .member_address {
      .el-input {
        margin-top: 10px;
      }
    }
  }
  .el-button {
    background: #4f4e95 !important;
    border: none;
    margin: 30px 160px 0;
  }
  /deep/.el-dialog{
    border-radius: 22px;
    margin-top: 30vh!important;
    .el-dialog__title{
      line-height: 60px;
      font-size: 20px;
      color: #303133;
      font-weight: bold;
    }
    i{
      position: absolute;
      right: 25px;
      top: 25px;
      font-size: 28px;
      font-weight: bold;
      cursor: pointer;
    }
    .pop-con{
      display: flex;
      justify-content: space-around;
      button{
        width:40%;
        display: block;
        background: #F12E2B;
        border-radius: 27px;
        font-size: 16px;
        color: #FFFFFF;
        padding:14px 0;
        margin-bottom: 9px;
        border: none;
      }
      button:last-child{
        background: #EEEEEE;
        color: #F12E2B;
      }
    }
    .contact {
      button{
        background: #FFFFFF;
        padding: 24px 30px;
        border-radius: 35px;
        box-shadow: 0 16px 20px 0 rgba(0,0,0,0.20);
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 11px auto 20px;
        border: none;

      }
      em{
        width: 20px;
        height: 20px;
        display: inline-block;
        background: url("../../assets/images/enterprises-menu08.png") no-repeat center center;
        background-size: contain;
      }
      span{
        font-size: 14px;
        color: #666666;
        line-height: 20px;
        margin-left: 8px;
      }
      b{
        font-size: 16px;
        color: #333333;
        line-height: 22px;
      }
    }
  }
}
 @media screen and (max-width: 768px){
    .company_info{
      margin: 0;
      padding: 0 20px;
      width: 100%;
      box-sizing: border-box;
    }
    .company_info h3{
      margin-top: 10px;
    }
    .company_info .el-button{
      margin: 30px 0;
    }
    .company_info .el-dialog .contact button{
      padding: 10px;
      box-shadow: 0 8px 10px 0 rgba(0,0,0,0.20);
    }
  }
</style>
